import StatusBar from "components/StatusBar";
import { number, shape } from "prop-types";
import React from "react";

import { SECTION_STATUS_COLORS, SECTION_STATUS_LABELS, SECTION_STATUS_ORDER } from "../../constants";

const TEST_ID = "section-status";
const UNIT_LABEL = "section";

const SectionStatusBar = ({ counts, total }) => {
  const segments = SECTION_STATUS_ORDER.map((status) => ({
    key: status,
    label: SECTION_STATUS_LABELS[status],
    color: SECTION_STATUS_COLORS[status],
    count: counts[status],
    showLabel: status !== "notStarted",
  }));

  return <StatusBar segments={segments} testId={TEST_ID} total={total} unitLabel={UNIT_LABEL} />;
};

SectionStatusBar.propTypes = {
  counts: shape({
    complete: number.isRequired,
    inReview: number.isRequired,
    drafting: number.isRequired,
    notStarted: number.isRequired,
  }).isRequired,
  total: number.isRequired,
};

export default SectionStatusBar;
